"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const createOsmosysFormContext = () => {
    const ctx = react_1.createContext(null);
    const useOsmosysForm = () => {
        const c = react_1.useContext(ctx);
        if (!c)
            throw new Error('useOsmosysForm must be inside a Provider with a value');
        return c;
    };
    return {
        OsmosysFormContextProvider: ctx.Provider,
        useOsmosysForm,
    };
};
_a = createOsmosysFormContext(), exports.OsmosysFormContextProvider = _a.OsmosysFormContextProvider, exports.useOsmosysForm = _a.useOsmosysForm;
//# sourceMappingURL=context.js.map